<template>
  <div
    class="character-card"
    :class="{ minor: props.data.minor, [props.data.class!]: !!props.data.class, exists: forceExists }"
  >
    <span v-if="props.data.title" class="title title-font">{{ props.data.title }}</span>
    <WikiLink class="title-font name" :wiki="props.data.name ?? props.data.name ?? ''" optional></WikiLink>
    <span v-if="infoText" class="info">{{ infoText }}</span>
    <div class="icons">
      <Icon v-for="icon in allIcons" :key="icon" :name="icon" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { getInfo, type CharacterData } from './familytree'

const props = defineProps<{
  data: CharacterData
  forceExists?: boolean
}>()

const allIcons = computed(() => [...(props.data.class ? [props.data.class] : []), ...(props.data.icons ?? [])])

const infoText = computed(() => getInfo(props.data, true, true))
</script>

<style scoped lang="postcss">
.character-card {
  position: relative;
  min-width: 6em;
  max-width: 14em;
  width: max-content;
  z-index: 10;
  text-align: center;
  display: flex;
  flex-direction: column;

  background: var(--background);
  border: 2px solid var(--primary);
  border-radius: 4px;
  padding: 0.5em;
  box-shadow: var(--card-shadow);

  &:not(.exists):has(> span.name),
  &.minor,
  &.spouse {
    padding: 0.25rem 0.5rem;
    font-size: 0.8em;
  }

  &:not(.exists):has(> span.name) {
    border-style: dotted;
  }

  .title {
    font-size: 0.8em;
    line-height: 1.2;
  }

  .info {
    font-size: 0.8em;
  }

  .name {
    color: var(--text-highlight);
  }

  .icons {
    position: absolute;
    top: -0.65em;
    left: -0.65em;

    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 0.5em;

    .icon {
      color: var(--text-highlight);
      width: 1.5em;
      height: 1.5em;
      background: var(--background);
      border: 2px solid var(--primary);
      border-radius: 50%;
    }
  }
}
</style>
